module.exports = __webpack_public_path__ + "img/picture-earth-mobile.ae1f85b5.jpg";